import { createTheme } from '@atlaskit/theme/components';
export var ThemeItem = createTheme(function () {
    return {
        backgroundColor: '',
    };
});
//# sourceMappingURL=item.js.map